// extracted by mini-css-extract-plugin
export default {"card":"eZ-z","carouselContainer":"fZ-z","carouselContent":"gZ-z"};